import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { secondsToMMSS } from '../../../Common/Utils';
import { BonusModel } from '../../../Models/Game/BonusModel';

export class UIBonusClockController extends AnimationBaseController {
    $model: BonusModel;

    public constructor(@Inject private _options) {
        super('UIBonusClockController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {};
    }

    protected onInitialize(): void {
        this.visible = true;
        this.gotoAndStop(this.$model.type);
    }

    protected onUpdate(frameRate: number) {
        if (this.visible) {
            const time = this._options.logic.getTime();

            if (time > 0) {
                this.setTextByQuery('text', secondsToMMSS(this._options.logic.getTime()));

            } else if (this.visible) {
                this.visible = false;
            }
        }
    }
}
